import toggleDarkModeThemeAction from './actions/toggleDarkModeTheme';
import DarkModeFull from './components/DarkModeFull';
import discardDarkModeOption from './orchestration/discardDarkModeOption';
import saveDarkModeOption from './orchestration/saveDarkModeOption';
import getIsDarkModeEnabledInUserSettings from './selectors/getIsDarkModeEnabledInUserSettings';
import getIsFullOptionDirty from './selectors/getIsFullOptionDirty';
import { isFeatureEnabled } from 'owa-feature-flags';
import { Option, QuickSettingOrder } from 'owa-options-core';
import { isCssVariablesSupported, isUserPersonalizationAllowed } from 'owa-theme';
import { OwaWorkload } from 'owa-workloads';
import * as React from 'react';

let DarkModeOption: Option = {
    key: 'darkMode',
    titleStringKey: 'options_theme_darkmode_toggle',
    searchTermsStringKey: 'options_theme_darkmode_toggle',
    fullOptionFormSettings: {
        render: () => <DarkModeFull />,
        isDirty: getIsFullOptionDirty,
        onSave: saveDarkModeOption,
        onDiscard: discardDarkModeOption,
    },
    quickOptionSettings: {
        rendering: {
            isToggleOn: getIsDarkModeEnabledInUserSettings,
            onToggle: toggleDarkModeThemeAction,
            isDisabled: () => !isCssVariablesSupported(),
        },
        getOrder: () => QuickSettingOrder.DarkMode,
        workloads: OwaWorkload.All,
        tooltip: {
            tooltipStringKey: () =>
                isCssVariablesSupported()
                    ? 'theme_dark_mode_some_themes_unavailable'
                    : 'theme_dark_mode_unavailable',
        },
    },
    isHidden: () => !isDarkModeEnabled(),
    allowedOptionKeys: ['Theme'],
};

export function isDarkModeEnabled(): boolean {
    return isFeatureEnabled('fwk-darkTheme') && isUserPersonalizationAllowed();
}

export default DarkModeOption;
